import type { InputLabelValue } from '@/types'

export const colors: string[] = [
  // 'slate',
  // 'gray',
  // 'zinc',
  // 'neutral',
  // 'stone',
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'pink',
  'rose',
  'fuchsia',
]

export const perPageLists: InputLabelValue[] = [
  {
    label: '10',
    value: 10,
  },
  {
    label: '25',
    value: 25,
  },
  {
    label: '50',
    value: 50,
  },
  {
    label: '100',
    value: 100,
  },
]

export const listMainButtonCrud: InputLabelValue[] = [
  { label: 'Edit', value: 'edit', icon: 'pencil-simple-line', color: 'amber' },
  { label: 'Trash', value: 'trash', icon: 'trash', color: 'red' },
]

export const iconJobType: string[] = ['question-mark', 'desk', 'van']

export const iconJobStatus: string[] = [
  'question-mark',
  'calendar',
  'timer',
  'screwdriver',
  'spinner-gap',
  'question-mark',
  'cpu',
  'hand-arrow-down',
  'check',
  'checks',
  'x',
  'hand-palm',
]

export const warrantyLists: InputLabelValue[] = [
  {
    label: 'Out-Warranty',
    value: 0,
  },
  {
    label: 'In-Warranty',
    value: 1,
    color: 'blue',
  },
]

export const technicianName: Record<number, string> = {
  3506: 'ALDO',
  3507: 'ERWIN',
}
